import { categories } from "@/mocks/ranking";

const icons = [
  "ri-tv-2-line",
  "ri-mic-2-line",
  "ri-shopping-bag-line",
  "ri-briefcase-2-line",
  "ri-basketball-line",
  "ri-lightbulb-flash-line",
];

const tints = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
];

export default function CategoryGrid() {
  return (
    <section id="category" className="mx-auto w-full max-w-7xl scroll-mt-16 px-4 py-12 md:px-6 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-serif text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            按圈层补课
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            从综艺热搜到圈外奇闻，选一个感兴趣的方向，快速补齐该领域今年的大瓜。
          </p>
        </div>
        <span className="hidden text-xs font-medium text-foreground-400 sm:inline">
          共 {categories.reduce((s, c) => s + c.count, 0)}+ 条收录
        </span>
      </div>

      <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, i) => (
          <a
            key={c.key}
            href="#hot"
            className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-2xl ${tints[i]}`}
            >
              <i className={icons[i]}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-serif text-lg font-bold text-foreground-950">{c.name}</h3>
                <i className="ri-arrow-right-line text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500"></i>
              </div>
              <p className="mt-1 text-sm leading-snug text-foreground-600">{c.desc}</p>
              <p className="mt-2 text-xs font-medium text-foreground-400">已收录 {c.count} 条热点</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}